// src/context/ClientContext.jsx
import React, { createContext, useContext, useReducer, useEffect } from "react";

const ClientContext = createContext();

const clientReducer = (state, action) => {
  switch (action.type) {
    case "SET_CLIENT":
      return {
        ...state,
        client: action.payload,
        isAuthenticated: true,
      };
    case "LOGOUT":
      return {
        ...state,
        client: null,
        isAuthenticated: false,
      };
    case "UPDATE_PROFILE":
      return {
        ...state,
        client: {
          ...state.client,
          profile: action.payload,
        },
      };
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};

const initialState = {
  client: null,
  isAuthenticated: false,
  loading: true,
};

export const ClientProvider = ({ children }) => {
  const [state, dispatch] = useReducer(clientReducer, initialState);

  useEffect(() => {
    const initializeClient = async () => {
      const clientData = localStorage.getItem("agritech-client");
      const token = localStorage.getItem("agritech-client-token");

      if (clientData && token) {
        try {
          // Verify token is still valid
          const response = await fetch(
            "https://agri-back-mauve.vercel.app/api/client-portal/verify",
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.ok) {
            dispatch({
              type: "SET_CLIENT",
              payload: JSON.parse(clientData),
            });
          } else {
            localStorage.removeItem("agritech-client-token");
            localStorage.removeItem("agritech-client");
          }
        } catch (error) {
          console.error("Token verification failed:", error);
          localStorage.removeItem("agritech-client-token");
          localStorage.removeItem("agritech-client");
        }
      }
      dispatch({ type: "SET_LOADING", payload: false });
    };

    initializeClient();
  }, []);

  const logout = () => {
    localStorage.removeItem("agritech-client-token");
    localStorage.removeItem("agritech-client");
    dispatch({ type: "LOGOUT" });
    window.location.href = "/client-portal";
  };

  const updateProfile = (profile) => {
    dispatch({ type: "UPDATE_PROFILE", payload: profile });
    localStorage.setItem(
      "agritech-client",
      JSON.stringify({
        ...state.client,
        profile,
      })
    );
  };

  const setClient = (client) => {
    dispatch({ type: "SET_CLIENT", payload: client });
  };

  return (
    <ClientContext.Provider
      value={{
        ...state,
        logout,
        updateProfile,
        setClient,
      }}
    >
      {children}
    </ClientContext.Provider>
  );
};

export const useClient = () => {
  const context = useContext(ClientContext);
  if (!context) {
    throw new Error("useClient must be used within a ClientProvider");
  }
  return context;
};
